import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
interface EmailGateProps {
  onSubmit: (email: string) => void;
}
export function EmailGate({
  onSubmit
}: EmailGateProps) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@') || !email.includes('.')) {
      setError(true);
      return;
    }
    setIsSubmitting(true);
    setError(false);
    setTimeout(() => {
      onSubmit(email);
      setIsSubmitting(false);
    }, 600);
  };
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem'
  }} data-id="element-31">
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }} data-id="element-32">
        <h2 style={{
        fontSize: 'clamp(1.5rem, 3.5vw, 1.875rem)',
        lineHeight: '1.2'
      }} data-id="element-33">
          Enter your email to see your result and get the guide
        </h2>
        <p style={{
        fontSize: '1.25rem',
        fontStyle: 'italic'
      }} data-id="element-34">
          No Theory. Just the Words That Matter.
        </p>
      </div>

      <form onSubmit={handleSubmit} style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }} data-id="element-35">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }} data-id="element-36">
          <Input type="email" placeholder="Email address" value={email} onChange={e => {
          setEmail(e.target.value);
          if (error) setError(false);
        }} error={error} autoFocus data-id="element-37" />
          {error && <p style={{
          fontSize: '0.875rem',
          color: '#ef4444'
        }} data-id="element-38">
              Please enter a valid email address.
            </p>}
        </div>
        <Button type="submit" fullWidth disabled={isSubmitting} data-id="element-39">
          {isSubmitting ? 'One moment...' : 'See my result and get the guide'}
        </Button>
      </form>
    </div>;
}